/**
 * @desc 导入采购信息模板下载
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/download/purchaseExcelTemp`, {
      method: "GET",

      ...options,
    }),
  );
}
